import { get, post, del } from '../global/ConfigRequest';
import {
    FEEDBACK_ADD_BOOKMARK_URL,
    FEEDBACK_DISLIKE_URL,
    FEEDBACK_LIKE_URL,
    FEEDBACK_LIST_URL, USER_FEEDBACK_LIST_URL, FEEDBACK_REMOVE_BOOKMARK_URL,
    FEEDBACK_SINGLE_URL,
    USER_FEEDBACK_SINGLE_URL
} from '../../helperData/ApiAddress';

export const getFeedbacks = (params, userType) => {
    if(userType === 'organ') return get(FEEDBACK_LIST_URL, params);
    if(userType === 'user') return get( USER_FEEDBACK_LIST_URL, params);
    
}

export const getFeedback = (id, user) => {
    if(user) return get(USER_FEEDBACK_SINGLE_URL.replace('{id}', id));
    return get(FEEDBACK_SINGLE_URL.replace('{id}', id));
}

export const likeFeedback = (id) => {
    return post(FEEDBACK_LIKE_URL.replace('{id}', id))
}

export const disLikeFeedback = (id) => {
    return post(FEEDBACK_DISLIKE_URL.replace('{id}', id))
}

export const addBookmark = (feedback) => {
    return post(FEEDBACK_ADD_BOOKMARK_URL, { feedback })
}

export const removeBookmark = (id, feedback) => {
    return del(FEEDBACK_REMOVE_BOOKMARK_URL.replace('{id}', id), { feedback })
}
